import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-06.jpg";
import aiImg from "../../assets/img/ai-WISrag.png";
import aiIcon01 from "../../assets/img/icon-ai16.png";
import aiIcon02 from "../../assets/img/icon-ai06.png";
import aiIcon03 from "../../assets/img/icon-ai01.png";
import aiIcon04 from "../../assets/img/icon-ai14.png";
import fwImg from "../../assets/img/fw-wisrag.png";

function WISplatform() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISrag 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">맞춤형 RAG 애플리케이션 솔루션</span>
						<h2>WISrag</h2>
						<p>기업의 방대한 데이터를 신뢰성 있는 지식의 언어로 변환하는 RAG 기반 맞춤형 애플리케이션.<br/> 할루시네이션 제어와 근거 중심 답변이 가능합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISrag 란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISrag" /></div>
            <div className="info">
              <p>WISrag는 RAG(Retrieval-Augmented Generation) 아키텍처를 기반으로, 기업의 내부 데이터와 최신 외부 정보를 결합하여 할루시네이션(환각) 관리를 강화하고, 실제 근거에 기반한 정확하고 신뢰성 높은 AI 답변 및 문서 생성을 지원하는 맞춤형 애플리케이션 솔루션입니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">입력/질문 분석</p>
                  <p className="txt">사용자의 질의 혹은 요청이 들어오면, 핵심 키워드와 의도를 파악</p>
                </li>
                 <li>
                  <p className="tit">벡터 임베딩 및 검색</p>
                  <p className="txt">입력 데이터를 임베딩(벡터화)하여, 벡터 데이터베이스나 다큐 먼트 저장소에서 의미적으로 가장 유사한 정보를 빠르게 검색</p>
                </li>
                 <li>
                  <p className="tit">LLM 연동 생성</p>
                  <p className="txt">검색된 정보를 LLM의 입력으로 함께 제공, LLM이 외부 참조 내용을 근거로 새롭게 답변/콘텐츠를 생성</p>
                </li>
                 <li>
                  <p className="tit">후처리 및 인용 관리</p>
                  <p className="txt">생성된 응답은 문법적, 내용적 후처리를 거쳐, 필요하면 인용·근거 표시가 추가되어 신뢰성 향상</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="할루시네이션(환각) 감소"/></span>
              <p className="tit">할루시네이션(환각)<br/>감소</p>
              <p className="txt">LLM의 “사실과 다른 답변(환각)” 가능성을 줄이고, 실제 문서 근거가 명확히 표시된 신뢰성 높은 결과 제공</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="최신정보반영, 기업 특화"/></span>
              <p className="tit">최신정보반영,<br/>기업 특화</p>
              <p className="txt">WISrag는 실시간 데이터 연결로 항상 최신 정보 반영 특정 산업/회사/업무별 전문 지식 (B2B 문서, 정책, 매뉴얼 등) 연동으로 도메인 특화 답변 가능</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="맞춤형 응답, 멀티모달 지원"/></span>
              <p className="tit">맞춤형 응답,<br/>멀티모달 지원</p>
              <p className="txt">답변 형식·길이·언어·참조 표시 등 기업 맞춤 정책 반영 가능 이미지, 오디오 등 다양한 포맷 연동과 추가 기능 확장</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="데이터 보안, 개인 정보 보호"/></span>
              <p className="tit">데이터 보안,<br/>개인 정보 보호</p>
              <p className="txt">기밀/민감 데이터의 외부 노출 없이, 내부 데이터베이스에서만 검색되고 사용</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">데이터 수집 및 전처리</p>
              </li>
              <li>
                <p className="tit">수집된 문서 청크 분할</p>
              </li>
              <li>
                <p className="tit">임베딩 생성 및 벡터DB 저장</p>
              </li>
              <li>
                <p className="tit">사용자 질의 임베딩 및 유사 청크 검색</p>
              </li>
              <li>
                <p className="tit">검색 결과와 LLM 입력 결합</p>
              </li>
              <li>
                <p className="tit">LLM 기반 응답 생성 및 반환</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework">
              <img src={fwImg} alt="WISrag 프레임워크" onClick={imgClick} />
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">기업 FAQ·고객지원 챗봇</p>
                <p className="txt">사내 문서·제품 매뉴얼·정책 Q&A를 정확히 답변하고, 명확한 지식 서비스 제공</p>
              </li>
                <li>
                <p className="tit">내부 지식 검색 및 보고서 생성</p>
                <p className="txt">방대한 내부 문서/리포트/가이드에서 원하는 정보를 실시간 추출, 맞춤형 보고서 자동 생성</p>
              </li>
                <li>
                <p className="tit">데이터 기반 의사결정 지원</p>
                <p className="txt">실시간 쿼리에 근거가 명시된 객관적 결과 전달(예: 법률, R&D, 정책 등)</p>
              </li>
                <li>
                <p className="tit">전문 정보의 빠른 전파와 관리</p>
                <p className="txt">기업 내 프라이빗 환경에서만 동작하며, 외부유출 없이 내부 지식 활용</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISplatform;